<ng-container *ngIf="loading">
  <div class="text-sm text-gray-500">Cargando...</div>
</ng-container>

<ng-container *ngIf="!loading && modo === 'select'">
  <select
    [(ngModel)]="selectedValue"
    (change)="onSelectChange($event)"
    [disabled]="disabled"
    class="w-full px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none text-sm disabled:bg-gray-100 disabled:cursor-not-allowed">
    <option value="">{{ placeholder }}</option>
    <option *ngFor="let opcion of opciones" [value]="opcion.valor">
      {{ opcion.valor }}
    </option>
  </select>
</ng-container>

<ng-container *ngIf="!loading && modo === 'checkboxes'">
  <div class="space-y-2">
    <label *ngFor="let opcion of opciones" class="flex items-center space-x-2 cursor-pointer">
      <input
        type="checkbox"
        [checked]="isSelected(opcion.codigo)"
        (change)="onCheckboxChange(opcion.codigo, $event)"
        [disabled]="disabled"
        class="w-[10%] h-4 text-orange-600 rounded border-gray-300 focus:ring-orange-500 disabled:opacity-50 disabled:cursor-not-allowed"
      />
      <span class="w-[90%] text-sm">{{ opcion.valor }}</span>
    </label>
  </div>
</ng-container>
